import { render, staticRenderFns } from "./ButtonSpeech.vue?vue&type=template&id=26fc63ae"
import script from "./ButtonSpeech.vue?vue&type=script&lang=js"
export * from "./ButtonSpeech.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports